import React, { useEffect } from 'react'
import type { Moment } from 'moment'
import { connect } from 'react-redux'

import { getTimesForDay } from '../../store/queueTimes'
import QueueTimeSlot from './Slot'

type QueueGap = {
  gapTime: string
  waitingMin: number
}

type QueueTimesData = {
  gaps: QueueGap[]
  openingTime: {
    from: string
    to: string
  }
}

type QueueTimesDayProps = {
  date: Moment
  times?: QueueTimesData
  getTimesForDay: (day: Moment) => unknown
}

function QueueTimesDay({ date, times, getTimesForDay }: QueueTimesDayProps) {
  useEffect(() => {
    getTimesForDay(date)
  }, [getTimesForDay, date])

  const renderTimes = () => {
    const renderedTimes = []
    const time = date.clone().hour(8).minutes(0)

    for (let i = 0; i < 32; i++) {
      const slot = times
        ? times.gaps.find((gap) => gap.gapTime === time.format('H:mm'))
        : null

      renderedTimes.push(
        <div className="QueueTimesDay__Slot" key={i}>
          <QueueTimeSlot
            time={time.format('HH:mm')}
            minutes={slot ? slot.waitingMin : null}
            noData={!times?.gaps.length}
            onClick={() =>
              (window.location.href =
                'https://www.miniatur-wunderland.' +
                (window.jsProps.lang === 'de' ? 'de' : 'com') +
                '/tickets/booking/' +
                date.format('YYYY-MM-DD'))
            }
          />
        </div>,
      )
      time.add(30, 'minutes')
    }
    return renderedTimes
  }

  return (
    <div className={'QueueTimesDay ' + (times ? '' : 'QueueTimesDay--no-data')}>
      <div className="QueueTimesDay__Header">
        <div className="QueueTimesDay__DayName">{date.format('dddd')}</div>
        <div className="QueueTimesDay__Month">{date.format('DD. MMMM')}</div>
        <div className="QueueTimesDay__OpeningHours">
          {window.jsProps.strings.openingHours}:{' '}
          {times && (
            <strong>
              {times.openingTime.from}-{times.openingTime.to}
            </strong>
          )}
        </div>
      </div>
      <div className="QueueTimesDay__Slots">{renderTimes()}</div>
    </div>
  )
}

const mapStateToProps = () => ({})

const mapDispatchToProps = {
  getTimesForDay,
}

export default connect(mapStateToProps, mapDispatchToProps)(QueueTimesDay)
